import { createContext, useContext } from 'react';

export type FeatureFlagMap = Record<string, boolean>;

export type FeatureFlagContextValue = {
    isLoading: boolean;
    flags: FeatureFlagMap;
};

/**
 * Populated by {@link CurrentUser} from the `providerPortalFeatureFlags` field of the
 * `CurrentUser` query, so that feature flags are fetched alongside the current user
 * instead of via a separate network request on every initial page load.
 */
export const FeatureFlagContext = createContext<FeatureFlagContextValue>({
    isLoading: true,
    flags: {},
});

export const useFeatureFlags = (): FeatureFlagContextValue => useContext(FeatureFlagContext);
